/*
 * @Description:
 * @Author: muqingkun
 * @Date: 2024-02-01 11:24:26
 * @LastEditTime: 2024-03-25 11:58:00
 * @LastEditors: muqingkun
 * @Reference:
 */
import Vue from 'vue'
import { orderPlaintext, waybillPlaintext } from '@api/base/public'

function getMaskData({ type, data }) {
  const api = {
    orderPlaintext,
    waybillPlaintext,
  }
  const apiType = data.apiType
  const apiFunction = type ? api[type] : api[data.waybillNo ? 'waybillPlaintext' : 'orderPlaintext']
  return apiFunction({ id: data.id, waybillNo: data.waybillNo, type: apiType })
}

export default {
  bind(el, binding) {
    const { data, key } = binding.value
    const span = document.createElement('span')
    const i = document.createElement('i')
    i.className = 'iconfont iconyincang mask_btn'
    span.innerHTML = data[key] || '--'
    el.appendChild(span)
    el.appendChild(i)
    el._mask_data = {
      originalData: data[key],
      maskedData: null,
      showMasked: false,
    }
    i.addEventListener('click', () => {
      if (el._mask_data.showMasked) {
        i.className = 'iconfont iconyincang mask_btn'
        el._mask_data.showMasked = false
        span.innerHTML = el._mask_data.originalData || '--'
      } else {
        console.log(binding.value, 'binding.value')
        getMaskData(binding.value).then((res) => {
          if (res.code === 1 && res.data[key]) {
            el._mask_data.showMasked = true
            el._mask_data.maskedData = res.data[key]
            i.className = 'iconfont iconxianshi mask_btn'
            span.innerHTML = res.data[key]
          }
          if (res.code !== 1) {
            Vue.prototype.$message.error(Vue.prototype.$lang(res.msg || '查询失败！'))
          }
        })
      }
    })
  },
  update(el, binding) {
    const { data, key } = binding.value
    const span = el.querySelector('span')
    if (el._mask_data.showMasked && span.innerHTML !== el._mask_data.maskedData) {
      span.innerHTML = el._mask_data.maskedData
    } else if (!el._mask_data.showMasked && span.innerHTML !== data[key]) {
      span.innerHTML = data[key] || '--'
    }
    el._mask_data.originalData = data[key]
  },
  unbind(el) {
    const i = el.querySelector('i')
    if (i) {
      i.removeEventListener('click', () => {})
    }
    delete el._mask_data
  },
}
